import http, { registerAPI } from './http'

/**
 * 向后端请求检测 email or company 可用性
 * 
 * @type {{
 *  request: (data: { email: string, company?: string }) => Promise<any>,
 *  abort: () => void
 * }}
 */
export const apiCheckCompany = registerAPI(http, {
  method: 'GET',
  url: '/v1/registration/check_company'
}, (data) => {
  const params = {
    'email': data.email,
  }

  if (data.company) {
    params.company = data.company
  }

  return params
})

/**
 * 提交注册信息
 * 
 * @type {{
 *  request: (data: {
 *    firstName: string,
 *    lastName: string,
 *    email: string,
 *    company: string,
 *    usecase: string,
 *    parameters: any,
 *    gtoken: string
 *  }) => Promise<any>,
 *  abort: () => void
 * }}
 */
export const apiRegister = registerAPI(http, {
  method: 'POST',
  url: '/v1/registration'
}, (data) => {
  return {
    'first_name': data.firstName,
    'last_name': data.lastName,
    'email': data.email,
    'company': data.company,
    'usecase': data.usecase,
    'parameters': JSON.stringify(data.parameters || {}),
    'gtoken': data.gtoken,
  }
})

/**
 * @type {{
 *  request: (token: string) => Promise<any>,
 *  abort: () => void
 * }}
 */
export const apiResendEmail = registerAPI(http, {
  method: 'PUT',
  url: '/v1/registration/resend_email'
}, (token) => {
  return {
    'reg_token': token
  }
})

/**
 * @type {{
 *  request: (token: string) => Promise<any>,
 *  abort: () => void
 * }}
 *
 * @example
 * ```
 * {
 *   code: 0
 *   message: success
 *   data: regtoken
 * }
 * ```
 */
export const apiVerifyEmail = registerAPI(http, {
  method: 'POST',
  url: '/v1/registration/verify_email'
}, (token) => {
  return {
    'token': token
  }
})

/**
 * @type {{
 *  request: (token: string) => Promise<any>,
 *  abort: () => void
 * }}
 * 
 * @example
 * ```
 * {
 *   code: 0
 *   message: success
 *   data: {
 *     tenant_active_url: xxxx
 *   }
 * }
 * ```
 */
export const apiCheckTenantStatus = registerAPI(http, {
  method: 'POST',
  url: '/v1/registration/check_tenant_status'
}, (token) => {
  return {
    'reg_token': token
  }
})

/**
 * @type {{
 *  request: (token: string) => Promise<any>,
 *  abort: () => void
 * }}
 */
export const apiRetryCheckTenant = registerAPI(http, {
  method: 'PUT',
  url: '/v1/registration/retry'
}, (token) => {
  return {
    'reg_token': token
  }
})
